import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack,
  Alert, Chip,
} from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";
import StopIcon from "@mui/icons-material/Stop";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const VideoSessions = () => {
  const [bookingId, setBookingId] = React.useState("");
  const [state, setState] = React.useState(null);
  const notify = useNotify();

  const fetchState = async () => {
    if (!bookingId.trim()) return;
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/consultations/${bookingId}/video/state`
      );
      setState(json);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setState(null);
    }
  };

  const endSession = async () => {
    try {
      await httpClient(`${API_BASE_URL}/consultations/${bookingId}/video/end`, {
        method: "POST",
      });
      notify("Session terminée", { type: "success" });
      fetchState();
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <VideocamIcon /> Sessions vidéo
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        État des sessions vidéo et clôture forcée des sessions actives.
      </Alert>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField size="small" label="Booking ID"
                value={bookingId} onChange={(e) => setBookingId(e.target.value)} />
              <Button variant="contained" onClick={fetchState}
                disabled={!bookingId.trim()}>
                Voir l'état
              </Button>
              <Button variant="outlined" color="error" startIcon={<StopIcon />}
                onClick={endSession} disabled={!bookingId.trim()}>
                Clôturer
              </Button>
            </Box>
            {state && (
              <Box>
                <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                  <Chip label={`Statut : ${state.status || "—"}`} color={
                    state.status === "ACTIVE" ? "success" :
                    state.status === "ENDED" ? "default" : "warning"
                  } />
                  {state.participants && (
                    <Chip label={`${state.participants.length} participant(s)`} />
                  )}
                </Stack>
                <Box component="pre" sx={{
                  bgcolor: "#f5f7fa", p: 1.5, borderRadius: 1,
                  fontFamily: "monospace", fontSize: 12, maxHeight: 400, overflow: "auto",
                }}>
                  {JSON.stringify(state, null, 2)}
                </Box>
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: VideoSessions };
